import { useState, useEffect, FC, useCallback, useMemo } from 'react';
import { Timeline, Button, Spin, message } from 'antd';
import { isEqual } from 'lodash';
import { DEFAULT_SORTER } from '../../utils/DataConstants';
interface OWPaginatedTimelineProps {
	targetCollectionName: string;
	fetchData: (params: any) => any;
	filters: any;
	sorting: any;
	pageSize: any;
	getDot: any;
	renderRecord: any;
	fetching: boolean;
	additionalParams: any;
}

const OWPaginatedTimeline: FC<OWPaginatedTimelineProps> = ({
	fetchData,
	renderRecord,
	getDot = null,
	pageSize = 10,
	sorting,
	additionalParams = {},
}): React.ReactElement => {
	const [fetching, setFetching] = useState(true);
	const [data, setData] = useState([]);
	const [hasMore, setHasMore] = useState(false);

	const sorters = useMemo(
		() => (sorting && !isEqual(sorting, {}) ? { ...sorting } : { ...DEFAULT_SORTER }),
		[sorting]
	);

	useEffect(() => {
		const params = {
			...additionalParams,
			...{
				offset: 0,
				limit: pageSize,
			},
			...sorters,
		};
		fetchData(params)
			.then((res) => {
				setData(res);
				setHasMore(res.length === pageSize);
			})
			.catch(message.error)
			.finally(() => setFetching(false));
	}, []);

	const handleLoadMore = useCallback(() => {
		const recordsCount = data.length;
		const page = recordsCount ? parseInt(`${recordsCount / pageSize}`) : 0;
		const pagination = {
			offset: page * pageSize,
			limit: pageSize,
		};

		const params = {
			...additionalParams,
			...pagination,
			...sorters,
		};

		setFetching(true);

		fetchData(params)
			.then((res) => {
				setData((existingData) => [...existingData, ...res]);
				setHasMore(res.length === pageSize);
			})
			.catch(message.error)
			.finally(() => setFetching(false));
	}, [additionalParams, data.length, fetchData, pageSize, sorters]);

	return (
		<div>
			<Timeline mode="left">
				{data.map((item) => (
					<Timeline.Item dot={getDot ? getDot(item) : null} key={item.id} className="mb-5">
						{renderRecord(item)}
					</Timeline.Item>
				))}
			</Timeline>
			{fetching && <Spin />}
			{hasMore && !fetching && (
				<Button onClick={handleLoadMore} block>
					Load More
				</Button>
			)}
		</div>
	);
};

export default OWPaginatedTimeline;
